import { Directive, computed, input } from '@angular/core';
import { type shared } from '@tig-dpqa-cloud/contract-backend-common';
import {
  getDisplayClassWithCssClass,
} from '../../util/get-display-class-for-slide-scan-status';

@Directive({
  selector: '[dpqaStatusIndicator]',
  standalone: true,
  host: {
    '[class.no-issues]': 'statusClass() === "no-issues"',
    '[class.has-issues]': 'statusClass() === "has-issues"',
    '[class.needs-review]': 'statusClass() === "needs-review"',
    '[class.qc-interrupted]': 'statusClass() === "qc-interrupted"',
  },
})
export class StatusIndicatorDirective {
  generalQcStatus = input.required<shared.SlideScanGeneralQcStatusType>();
  aggregatedStatus = input<shared.AggregatedStatusType | undefined>(undefined);
  detectedIssues = input<shared.SlideScanDetectedIssue[]>([]);
  aiProcessingStatus = input.required<shared.SlideScanItemAIProcessingStatusType>();
  isEditing = input<boolean>(false);

  statusClass = computed(() => {
    const { cssClass } = getDisplayClassWithCssClass({
      aiProcessingStatus: this.aiProcessingStatus(),
      detectedIssues: this.detectedIssues(),
      isEditing: this.isEditing(),
      generalQcStatus: this.generalQcStatus(),
      aggregatedStatus: this.aggregatedStatus(),
    });

    return cssClass;
  });
}
